import { combineReducers } from "@reduxjs/toolkit";
import navReducer from "./Nav/navSlice";

const layoutReducer = combineReducers({ nav: navReducer });

export default layoutReducer;
